var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49513 7.81514C2.63669 7.81514 1.94078 8.51105 1.94078 9.36949V17.2825C1.94078 18.141 2.63669 18.8369 3.49513 18.8369H17.0603C17.9188 18.8369 18.6147 18.141 18.6147 17.2825V9.36949C18.6147 8.51105 17.9188 7.81514 17.0603 7.81514H3.49513ZM0.52774 9.36949C0.52774 7.73065 1.85629 6.4021 3.49513 6.4021H17.0603C18.6992 6.4021 20.0277 7.73065 20.0277 9.36949V17.2825C20.0277 18.9214 18.6992 20.2499 17.0603 20.2499H3.49513C1.85629 20.2499 0.52774 18.9214 0.52774 17.2825V9.36949Z",
    fill: "#1E1542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91937 4.28261C3.91937 2.33241 5.50178 0.75 7.45198 0.75C9.40218 0.75 10.9846 2.33241 10.9846 4.28261V7.1087C10.9846 7.4989 10.6683 7.81522 10.2781 7.81522H7.45198C5.50178 7.81522 3.91937 6.23281 3.91937 4.28261ZM7.45198 2.16304C6.28218 2.16304 5.33242 3.11281 5.33242 4.28261C5.33242 5.45241 6.28218 6.40217 7.45198 6.40217H9.57155V4.28261C9.57155 3.11281 8.62178 2.16304 7.45198 2.16304Z",
    fill: "#1E1542"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1038 2.16304C11.934 2.16304 10.9842 3.11281 10.9842 4.28261V6.40217H13.1038C14.2736 6.40217 15.2233 5.45241 15.2233 4.28261C15.2233 3.11281 14.2736 2.16304 13.1038 2.16304ZM9.57117 4.28261C9.57117 2.33241 11.1536 0.75 13.1038 0.75C15.054 0.75 16.6364 2.33241 16.6364 4.28261C16.6364 6.23281 15.054 7.81522 13.1038 7.81522H10.2777C9.88749 7.81522 9.57117 7.4989 9.57117 7.1087V4.28261Z",
    fill: "#1E1542"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2777 5.27173C10.6679 5.27173 10.9842 5.58805 10.9842 5.97825H10.2777H9.57117C9.57117 5.58805 9.88749 5.27173 10.2777 5.27173ZM10.2777 5.97825C9.57117 5.97825 9.57117 5.97819 9.57117 5.97825V19.5435C9.57117 19.9337 9.88749 20.25 10.2777 20.25C10.6679 20.25 10.9842 19.9337 10.9842 19.5435V5.97825C10.9842 5.97819 10.9842 5.97825 10.2777 5.97825Z",
    fill: "#1E1542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentDarkIcon);
export default __webpack_public_path__ + "static/media/presentDarkIcon.8ec31a88ecab069d15e6ef1cf7a446cc.svg";
export { ForwardRef as ReactComponent };